<style>
</style>

<template>
<div id="login--view">
  <v-dialog v-model="dialog" persistent max-width="440px">
      <v-toolbar fixed flat height="80px">
        <v-spacer></v-spacer>
        <v-toolbar-title class="justify-center headline primary--text">
          {{ $t('Děkujeme za registraci') }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
    <v-card class="background: secondary pt-10" height="240px">
      <v-card-text class="text-center headline">{{
          $t('Vaše registrace byla úspěšne dokončena')
        }}
      </v-card-text>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
import InstitutionMixin from '@gravela/vue-component-library/src/mixins/institution-mixin.js'
import StorageMixin from '@/mixins/storage-mixin.js'
const eshop = require('@/oauth2/eshop.json')
const kzona = require('@/oauth2/kzona.json')

export default {
  name: 'LoginPage',
  mixins: [InstitutionMixin, StorageMixin],
  data() {
    return {
      dialog: false
    }
  },
  mounted() {
    const account = this.$route.query.account ? { account: this.$route.query.account } : {}
    this.dialog = this.$route.query.account != null
    setTimeout(() => {
      this.dialog = false
      process.nextTick(() => {
        const hasGuestToken = this.hasAccessToken && this.isGuest
        const oauth2 = hasGuestToken ? kzona : eshop
        this.$iframe.iframe.width = hasGuestToken ? '320px' : '0px'
        this.$iframe.iframe.height = hasGuestToken ? '440px' : '0px'
        this.$iframe.iframe.redirectUrl = this.$oauth2.redirectAuthUrl(oauth2, this.institutionId, account)
        this.$iframe.iframe.backUrl = (this.$oauth2.getRedirectUrl(oauth2.redirectPath) + '?code=' + 'NOSIGN')
      })}, this.$route.query.account ? 3000 : 0)
  },
  computed: {
    query: {
      get() {
        return this.$route.query
      }
    }
  }
}
</script>
